import React, { Fragment, useLayoutEffect, useReducer } from 'react'
import { BrowserRouter, Route } from 'react-router-dom'

import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core/styles'

import moment from 'moment'
import 'moment/locale/pt-br'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'

import { theme, inverse } from './theme'
import useFirebase from './useFirebase'
import Root from './pages'
import SignIn from './pages/signin'

import errorHandler from './errorHandler'
import withApollo from './withApollo'

moment.locale('pt-BR')

const initialState = { logged: false, loading: true }

function reducer(state, action) {
  switch (action.type) {
    case 'reset':
      return initialState
    case 'loggedin':
      return { ...state, logged: true }
    case 'loading':
      return { ...state, loading: action.payload }
    default:
      // A reducer must always return a valid state.
      // Alternatively you can throw an error if an invalid action is dispatched.
      return state
  }
}

function App() {
  const firebase = useFirebase()
  const [state, dispatch] = useReducer(reducer, initialState)
  console.log('#AppStarting', state)

  useLayoutEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        console.log('#onAuthStateChanged', user.toJSON())

        user.getIdToken().then(token => {
          console.log(token)
          errorHandler.setUser(user.uid)
          window.token = token
          setTimeout(() => {
            window.FB && window.FB.CustomerChat.hide()
          }, 3000)

          dispatch({ type: 'loggedin' })
          dispatch({ type: 'loading', payload: false })
        })
      } else {
        // User is signed out.
        window.token = null
        dispatch({ type: 'reset' })
        dispatch({ type: 'loading', payload: false })
      }
    })
  }, [])

  const primary = createMuiTheme(theme)
  console.log(primary)
  return (
    <Fragment>
      <CssBaseline />
      {!state.loading && !state.logged && (
        <ThemeProvider theme={createMuiTheme(inverse)}>
          <SignIn />
        </ThemeProvider>
      )}
      {state.logged && (
        <BrowserRouter>
          <ThemeProvider theme={primary}>
            <MuiPickersUtilsProvider
              utils={MomentUtils}
              moment={moment}
              locale="pt-BR">
              <Route path="/" component={Root} />
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </BrowserRouter>
      )}
    </Fragment>
  )
}

export default withApollo(App)
